<ion-header>
  <ion-toolbar>
    <ion-title> Select type of property you would like to add </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="add-listing-wrapper">
    <button type="button" class="cnt-button" (click)="host()">
      <span class="cnt-button-icon _24px host">
        <span class="html-embed w-embed">
          <curbnturf-map-icons type="pricePinFilled" [primary]="true"> </curbnturf-map-icons>
        </span>
      </span>
      <span class="cnt-button-copy">Private Property</span>
    </button>

    <button type="button" class="cnt-button" (click)="boondock()">
      <span class="cnt-button-icon">
        <span class="html-embed w-embed">
          <curbnturf-map-icons type="boondockPinLarge" [green]="true"> </curbnturf-map-icons>
        </span>
      </span>
      <span class="cnt-button-copy">Boondocking Property</span>
    </button>

    <button type="button" class="cnt-button" (click)="openPoiNewModal()">
      <span class="cnt-button-icon">
        <span class="html-embed w-embed">
          <curbnturf-map-icons type="boondockPinLarge" [primary]="true"> </curbnturf-map-icons>
        </span>
      </span>
      <span class="cnt-button-copy">Point of Interest</span>
    </button>
  </div>
</ion-content>
